import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
    name: 'csTranslate',
})
export class MultilingualPipe implements PipeTransform {
    localeDefault = 'fr_FR';
    languages = environment.languages;

    transform(value: any, lang: string): string {
        try {
            let locale = this.languages.find(l => l.code === lang)?.locale;
            if (locale) {
                return this.getValue(value, locale);
            } else {
                if (this.getValue(value, this.localeDefault)) {
                    return this.getValue(value, this.localeDefault);
                } else {
                    throw new Error();
                }
            }
        } catch (e) {
            return '-';
        }
    }

    getValue(value: any, locale: string) {
        try {
            if (value[locale] || value[this.localeDefault]) {
                return value[locale] ? value[locale] : value[this.localeDefault];
            } else {
                return value.get(locale) ? value.get(locale) : value.get(this.localeDefault);
            }
        } catch (e) {            
            return null;
        }
    }
}


